import { Vertical } from './Verticals';

export type Category = {
    id: string;
    title: string;
    metaTitle: string;
    subtitle: string;
    description: string;
    metaDescription: string;
} & {
    type: 'vertical';
    vertical: Vertical;
};

export const BLOG_CATEGORIES: Category[] = [
    {
        id: 'weight-loss',
        title: 'Weight Loss',
        metaTitle: "Women's Weight Loss Tips & Strategies | Moshy",
        subtitle:
            'Weight Loss for Women: Expert Tips, Diets, and Sustainable Strategies',
        description:
            "Welcome to Moshy's Weight Loss blog for women, your ultimate resource for expert tips, diets, and sustainable strategies to help you achieve your weight loss goals. Whether you're looking to shed a few pounds or embark on a significant weight loss journey, our comprehensive articles provide valuable insights and practical advice tailored specifically for women. Explore topics such as balanced diets, effective workout routines, mindful eating, and personalised weight loss plans. Empower yourself with the knowledge and tools you need to lose weight healthily and maintain your results long-term. Start your journey to a healthier you with Moshy today.",
        metaDescription:
            'Discover effective weight loss tips, diets, and strategies for women. Learn how to lose weight sustainably with expert advice from Moshy. Visit our Weight Loss blog now.',
        type: 'vertical',
        vertical: Vertical.WEIGHT_LOSS,
    },
    {
        id: 'womens-skincare',
        title: "Women's Skincare",
        metaTitle: "Women's Skincare Tips & Solutions | Moshy Beauty Blog",
        subtitle:
            'Skincare for Women: Expert Tips, Routines, and Product Recommendations',
        description:
            "Welcome to Moshy's Women's Skincare blog, your ultimate resource for expert advice, beauty tips, and personalised skincare solutions tailored specifically for women. Whether you're looking to address specific skin concerns, develop an effective skincare routine, or explore the latest beauty trends, our comprehensive articles provide valuable insights and practical guidance. From anti-aging treatments to acne solutions, and from natural skincare to cutting-edge beauty tech, we cover a wide range of topics to help you achieve and maintain healthy, radiant skin at any age. Discover how to enhance your natural beauty, boost your confidence, and care for your skin with Moshy's trusted expertise. Start your journey to glowing, vibrant skin today.",
        metaDescription:
            "Discover expert women's skincare tips, routines, & product recommendations. Achieve radiant, healthy skin at any age with Moshy. Visit our Women's Skincare blog now.",
        type: 'vertical',
        vertical: Vertical.SKIN,
    },
];
